<template>
  <div class="about">
    <div class="name">Certificate</div>
    <br />
    <div class="cer-img">
      <img src="../images/cert1.png" />
      <img src="../images/cert2.png" />
      <img src="../images/cert3.png" />
      <img src="../images/cert4.png" />
      <img src="../images/cert5.png" />
      <img src="../images/cert6.png" />
      <img src="../images/cert7.jpg" />
      <img src="../images/cert8.jpg" />
      <img src="../images/cert9.jpg" />
      <img src="../images/cert11.png" />
      <img src="../images/cert12.png" />
      <img src="../images/cert13.png" />
      <img src="../images/cert14.png" />
      <img src="../images/cert15.jpg" />
      <img src="../images/cert16.jpg" />
      <img src="../images/cert17.jpg" />
      <img src="../images/cert18.jpg" />
      <img src="../images/cert19.jpg" />
      <img src="../images/cert20.jpg" />
      <img src="../images/cert21.jpg" />
      <img src="../images/cert22.jpg" />
      <img src="../images/cert23.jpg" />
      <img src="../images/cert24.jpg" />
      <img src="../images/cert25.jpg" />
      <img src="../images/cert26.jpg" />
      <img src="../images/cert27.jpg" />
      <img src="../images/cert28.jpg" />
      <img src="../images/cert29.jpg" />
      <img src="../images/cert30.jpg" />
      <img src="../images/cert31.jpg" />
      <img src="../images/cert32.jpg" />
      <img src="../images/cert33.jpg" />
      <img src="../images/cert34.jpg" />
      <img src="../images/cert35.jpg" />
      <img src="../images/cert36.jpg" />
      <img src="../images/cert37.jpg" />
      <img src="../images/cert38.jpg" />
      <img src="../images/cert39.jpg" />
      <img src="../images/cert40.jpg" />
      <img src="../images/cert41.jpg" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
    };
  },
  methods: {},
  created() {},
  components: {},
};
</script>

